<!-- 品牌运营服务 -->
<template>
<div class="site-content">
  <div class="site-content-banner">
    <img src="./../../assets/ppyy_banner.jpg"/>
  </div>
  <div class="site-content-page width-per-100">
    <div class="content-row">
      <div class="content-col">
         <infoList :showTitle="true" :showMore="false" :infoBlock="infoBlock1" title="品牌服务" label="INDUSTRY SERVICE" count="4" :infoPage="infoPage1" v-on:queryPage="ppfw_Req"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoList from '../block/InfoList'
import PpfwInfo1 from '../module/PpfwInfo1'
export default {
  name: 'Jrfw01',
  components: {
    'infoList': InfoList,
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App---template',
      infoBlock1:PpfwInfo1,
      infoPage1:{list:[],total:0},
    }
  },
  methods:{
    //品牌服务
    ppfw_Req(params){
          let that=this;
          params.p=1;
          params.type="品牌服务";
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.orgServiceLists(params).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage1=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.width-per-100{
  width:100%;
}
.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Cyfw02.vue